import { DateTime as DateTime$1 } from "../../../../../components/DateTime/index.js";
import "react";
import { Icon, Tooltip } from "@therms/atalaya";
import { FaStar } from "react-icons/fa";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { FaCheck } from "react-icons/fa6";
//#region src/modules/AppWrapper2/components/AppNav/components/RegionItem.tsx
function RegionItem({ id, isActive, isDisabled, isPrimary, name, onClick, showTimezoneTime, timezone }) {
	return /* @__PURE__ */ jsxs("button", {
		disabled: isDisabled,
		className: classnames({ "hover:bg-surface-subtle hover:text-color-strong transition-colors": !isDisabled }, "p-xs flex w-full items-center rounded text-left"),
		onClick,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex-1 font-medium",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "space-x-xxs",
				children: [isPrimary && /* @__PURE__ */ jsx(Tooltip, {
					tooltip: /* @__PURE__ */ jsx("div", {
						className: "min-w-max",
						children: "Primary Region"
					}),
					children: /* @__PURE__ */ jsx(Icon, {
						className: "pr-xxs",
						color: "info",
						Icon: FaStar,
						size: "xs"
					})
				}), /* @__PURE__ */ jsx("span", {
					className: "text-sm",
					children: name
				})]
			}), showTimezoneTime && /* @__PURE__ */ jsxs("div", {
				className: "text-color-neutral truncate text-xs",
				children: [
					/* @__PURE__ */ jsx(DateTime$1, {
						toggleRelativeOnClick: false,
						mode: "time",
						timestamp: (/* @__PURE__ */ new Date()).toISOString(),
						timezone
					}),
					" ",
					/* @__PURE__ */ jsxs("span", { children: [
						"(",
						timezone,
						")"
					] })
				]
			})]
		}), isActive && /* @__PURE__ */ jsx(Icon, {
			className: "ml-sm",
			color: "positive",
			Icon: FaCheck,
			size: "sm"
		})]
	});
}
//#endregion
export { RegionItem };

//# sourceMappingURL=RegionItem.js.map